<template lang="pug">
b-modal#addSlideBanner(
  ref="addSlideBanner"
  :title="$t('ui.combine.add_slide_banner')"
  centered
  no-fade
  no-close-on-backdrop
  size="lg"
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    .row.mb-3
      div.col-sm-12.col-md-4.col-lg-4
        b-form-group(:label="$t('ui.target')").mb-0
          b-form-select(
            :dirty="$v.target_window.$dirty"
            :error="$v.target_window.$error"
            v-model.trim.lazy="$v.target_window.$model"
            :disabled="loading"
            size="sm"
          )
            option(value="" disabled) {{ $t('message.select_option') }}
            option(value="_blank") {{ $t('ui.new_window_tab') }}
            option(value="_self") {{ $t('ui.current_page') }}
          ValidateResult(:value="$v.target_window" :name="$t('ui.target')")
      div.col-sm-12.col-md-4.col-lg-4
        b-form-group(:label="$t('ui.default_order')").mb-2
          div.d-flex
            label.custom-switch
              input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="default_order")
              span.custom-switch-indicator
          ValidateResult(:value="$v.default_order" :name="$t('ui.default_order')")
      div.col-sm-12.col-md-4.col-lg-4(v-if="default_order == false")
        b-form-group(:label="$t('ui.item_order')").mb-0
          CMSBannerCount(
            :operatorID="operatorID"
            ref="item_order"
            size="sm"
            required
            type="array"
            :dirty="$v.item_order.$dirty"
            :error="$v.item_order.$error"
            v-model.trim.lazy="$v.item_order.$model"
            bType="slide"
            :disabled="loading"
            :viewType="viewType"
          )
          ValidateResult(:value="$v.item_order" :name="$t('ui.item_order')")
    .row
      div.col-sm-12.col-md-4.col-lg-4
        b-form-group(:label="$t('ui.login_required')").mb-2
          div.d-flex
            label.custom-switch
              input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="login_required")
              span.custom-switch-indicator

          ValidateResult(:value="$v.login_required" :name="$t('ui.login_required')")
      div.col-sm-12.col-md-8.col-lg-8
        div(width="70%").mr-3
          b-form-group(:label="$t('ui.active_period')").mb-2
            DateRangePicker(:value="dateRange" @update="getData")
    .row
      .col-12 
        ul#editorTab.nav.nav-tabs(role='tablist')
          li.nav-item
            a#enSlideAdd-tab.nav-link(data-toggle='tab' href='#enSlideAdd-content' role='tab' aria-controls='enSlideAdd' aria-selected='false' @click="setTab('en')" :class="activeTab == 'en' ? 'active' : ''") {{ $t("ui.en") }}
          li.nav-item
            a#cnSlideAdd-tab.nav-link(data-toggle='tab' href='#cnSlideAdd-content' role='tab' aria-controls='cnSlideAdd' aria-selected='false' @click="setTab('cn')" :class="activeTab == 'cn' ? 'active' : ''") {{ $t("ui.cn") }}
          li.nav-item
            a#localSlideAdd-tab.nav-link(data-toggle='tab' href='#localSlideAdd-content' role='tab' aria-controls='localSlideAdd' aria-selected='false' @click="setTab('local')" :class="activeTab == 'local' ? 'active' : ''") {{ $t("ui.local") }}

        #editorcontent.tab-content.tab-bordered
          #enSlideAdd-content.tab-pane(:class="activeTab == 'en' ? 'active show' : 'fade'" role='tabpanel' aria-labelledby='enSlideAdd-tab')
            div.d-flex.flex-wrap
              b-form-group.w-100(:label="$t('ui.alt')").mb-0
                DebounceInput(
                  size="sm"
                  ref="en_alt"
                  type="text"
                  :dirty="$v.en_alt.$dirty"
                  :error="$v.en_alt.$error"
                  v-model.trim.lazy="$v.en_alt.$model"
                  :disabled="loading"
                )
                ValidateResult(:value="$v.en_alt" :name="$t('ui.en_alt')")
              b-form-group.w-100.mb-0
                label {{ $t('ui.href') }}
                i.fa.fa-info-circle.text-info.ml-2(:title="$t('message.tooltips_href')")
                DebounceInput(
                  size="sm"
                  ref="en_href"
                  type="text"
                  :dirty="$v.en_href.$dirty"
                  :error="$v.en_href.$error"
                  v-model.trim.lazy="$v.en_href.$model"
                  :disabled="loading"
                )
                ValidateResult(:value="$v.en_href" :name="$t('ui.en_href')")
              .alert.alert-warning.p-1.mb-2.w-100(v-if="imgSize && imgSize[themeCode]") *{{ $t("message.banner_size_tooltips", { size: imgSize[themeCode][3] }) }}
              b-form-group.w-100(:label="$t('ui.image_desktop')").mb-0
                b-form-file(
                  :dirty="$v.en_image_desktop.$dirty"
                  :error="$v.en_image_desktop.$error"
                  v-model.trim.lazy="$v.en_image_desktop.$model"
                  ref="file"
                  accept="image/jpeg, image/png, image/jpg"
                  @change="onSelectEnDesktop"
                  v-if="enDesktopImageSrc == null"
                )
                small.form-text.text-muted {{ $t('message.tooltips_upload_size') }} 
                ValidateResult(:value="$v.en_image_desktop" :name="$t('ui.en_image_desktop')")
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-times"
                  :text="$t('ui.remove_desktop_image')"
                  type="button"
                  @click="removeEnDesktopImage()"
                  variant="danger"
                  size="sm"
                  v-if="enDesktopImageSrc != null"
                  )
                br
                b-img.w-50.h-50(v-if="enDesktopImageSrc != null" :src="enDesktopImageSrc")
              .alert.alert-warning.p-1.mb-2.w-100(v-if="imgSize && imgSize[themeCode]") *{{ $t("message.banner_size_tooltips", { size: imgSize[themeCode][4] }) }}
              b-form-group.w-100(:label="$t('ui.image_mobile')").mb-0
                b-form-file(
                  :dirty="$v.en_image_mobile.$dirty"
                  :error="$v.en_image_mobile.$error"
                  v-model.trim.lazy="$v.en_image_mobile.$model"
                  ref="file"
                  accept="image/jpeg, image/png, image/jpg"
                  @change="onSelectEnMobile"
                  v-if="enMobileImageSrc == null"
                )
                small.form-text.text-muted {{ $t('message.tooltips_upload_size') }} 
                ValidateResult(:value="$v.en_image_mobile" :name="$t('ui.en_image_mobile')")
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-times"
                  :text="$t('ui.remove_mobile_image')"
                  type="button"
                  @click="removeEnMobileImage()"
                  variant="danger"
                  size="sm"
                  v-if="enMobileImageSrc != null"
                  )
                br
                b-img.w-50.h-50(v-if="enMobileImageSrc != null" :src="enMobileImageSrc")

          #cnSlideAdd-content.tab-pane(:class="activeTab == 'cn' ? 'active show' : 'fade'" role='tabpanel' aria-labelledby='cnSlideAdd-tab')
            div.d-flex.flex-wrap
              b-form-group.w-100(:label="$t('ui.alt')").mb-0
                DebounceInput(
                  size="sm"
                  ref="cn_alt"
                  type="text"
                  :dirty="$v.cn_alt.$dirty"
                  :error="$v.cn_alt.$error"
                  v-model.trim.lazy="$v.cn_alt.$model"
                  :disabled="loading"
                )
                ValidateResult(:value="$v.cn_alt" :name="$t('ui.cn_alt')")
              b-form-group.w-100.mb-0
                label {{ $t('ui.href') }}
                i.fa.fa-info-circle.text-info.ml-2(:title="$t('message.tooltips_href')")
                DebounceInput(
                  size="sm"
                  ref="cn_href"
                  type="text"
                  :dirty="$v.cn_href.$dirty"
                  :error="$v.cn_href.$error"
                  v-model.trim.lazy="$v.cn_href.$model"
                  :disabled="loading"
                )
                ValidateResult(:value="$v.cn_href" :name="$t('ui.cn_href')")
              .alert.alert-warning.p-1.mb-2.w-100(v-if="imgSize && imgSize[themeCode]") *{{ $t("message.banner_size_tooltips", { size: imgSize[themeCode][3] }) }}
              b-form-group.w-100(:label="$t('ui.image_desktop')").mb-0
                b-form-file(
                  :dirty="$v.cn_image_desktop.$dirty"
                  :error="$v.cn_image_desktop.$error"
                  v-model.trim.lazy="$v.cn_image_desktop.$model"
                  ref="file"
                  accept="image/jpeg, image/png, image/jpg"
                  @change="onSelectCnDesktop"
                  v-if="cnDesktopImageSrc == null"
                )
                small.form-text.text-muted {{ $t('message.tooltips_upload_size') }} 
                ValidateResult(:value="$v.cn_image_desktop" :name="$t('ui.cn_image_desktop')")
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-times"
                  :text="$t('ui.remove_desktop_image')"
                  type="button"
                  @click="removeCnDesktopImage()"
                  variant="danger"
                  size="sm"
                  v-if="cnDesktopImageSrc != null"
                  )
                br
                b-img.w-50.h-50(v-if="cnDesktopImageSrc != null" :src="cnDesktopImageSrc")
              .alert.alert-warning.p-1.mb-2.w-100(v-if="imgSize && imgSize[themeCode]") *{{ $t("message.banner_size_tooltips", { size: imgSize[themeCode][4] }) }}
              b-form-group.w-100(:label="$t('ui.image_mobile')").mb-0
                b-form-file(
                  :dirty="$v.cn_image_mobile.$dirty"
                  :error="$v.cn_image_mobile.$error"
                  v-model.trim.lazy="$v.cn_image_mobile.$model"
                  ref="file"
                  accept="image/jpeg, image/png, image/jpg"
                  @change="onSelectCnMobile"
                  v-if="cnMobileImageSrc == null"
                )
                small.form-text.text-muted {{ $t('message.tooltips_upload_size') }} 
                ValidateResult(:value="$v.cn_image_mobile" :name="$t('ui.cn_image_mobile')")
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-times"
                  :text="$t('ui.remove_mobile_image')"
                  type="button"
                  @click="removeCnMobileImage()"
                  variant="danger"
                  size="sm"
                  v-if="cnMobileImageSrc != null"
                  )
                br
                b-img.w-50.h-50(v-if="cnMobileImageSrc != null" :src="cnMobileImageSrc")

          #localSlideAdd-content.tab-pane(:class="activeTab == 'local' ? 'active show' : 'fade'" role='tabpanel' aria-labelledby='localSlideAdd-tab')
            div.d-flex.flex-wrap
              b-form-group.w-100(:label="$t('ui.alt')").mb-0
                DebounceInput(
                  size="sm"
                  ref="local_alt"
                  type="text"
                  :dirty="$v.local_alt.$dirty"
                  :error="$v.local_alt.$error"
                  v-model.trim.lazy="$v.local_alt.$model"
                  :disabled="loading"
                )
                ValidateResult(:value="$v.local_alt" :name="$t('ui.local_alt')")
              b-form-group.w-100.mb-0
                label {{ $t('ui.href') }}
                i.fa.fa-info-circle.text-info.ml-2(:title="$t('message.tooltips_href')")
                DebounceInput(
                  size="sm"
                  ref="local_href"
                  type="text"
                  :dirty="$v.local_href.$dirty"
                  :error="$v.local_href.$error"
                  v-model.trim.lazy="$v.local_href.$model"
                  :disabled="loading"
                )
                ValidateResult(:value="$v.local_href" :name="$t('ui.local_href')")
              .alert.alert-warning.p-1.mb-2.w-100(v-if="imgSize && imgSize[themeCode]") *{{ $t("message.banner_size_tooltips", { size: imgSize[themeCode][3] }) }}
              b-form-group.w-100(:label="$t('ui.image_desktop')").mb-0
                b-form-file(
                  :dirty="$v.local_image_desktop.$dirty"
                  :error="$v.local_image_desktop.$error"
                  v-model.trim.lazy="$v.local_image_desktop.$model"
                  ref="file"
                  accept="image/jpeg, image/png, image/jpg"
                  @change="onSelectLocalDesktop"
                  v-if="localDesktopImageSrc == null"
                )
                small.form-text.text-muted {{ $t('message.tooltips_upload_size') }} 
                ValidateResult(:value="$v.local_image_desktop" :name="$t('ui.local_image_desktop')")
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-times"
                  :text="$t('ui.remove_desktop_image')"
                  type="button"
                  @click="removeLocalDesktopImage()"
                  variant="danger"
                  size="sm"
                  v-if="localDesktopImageSrc != null"
                  )
                br
                b-img.w-50.h-50(v-if="localDesktopImageSrc != null" :src="localDesktopImageSrc")
              .alert.alert-warning.p-1.mb-2.w-100(v-if="imgSize && imgSize[themeCode]") *{{ $t("message.banner_size_tooltips", { size: imgSize[themeCode][4] }) }}
              b-form-group.w-100(:label="$t('ui.image_mobile')").mb-0
                b-form-file(
                  :dirty="$v.local_image_mobile.$dirty"
                  :error="$v.local_image_mobile.$error"
                  v-model.trim.lazy="$v.local_image_mobile.$model"
                  ref="file"
                  accept="image/jpeg, image/png, image/jpg"
                  @change="onSelectLocalMobile"
                  v-if="localMobileImageSrc == null"
                )
                small.form-text.text-muted {{ $t('message.tooltips_upload_size') }} 
                ValidateResult(:value="$v.local_image_mobile" :name="$t('ui.local_image_mobile')")
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-times"
                  :text="$t('ui.remove_mobile_image')"
                  type="button"
                  @click="removeLocalMobileImage()"
                  variant="danger"
                  size="sm"
                  v-if="localMobileImageSrc != null"
                  )
                br
                b-img.w-50.h-50(v-if="localMobileImageSrc != null" :src="localMobileImageSrc")

    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, minValue, maxValue, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import CMSBannerCount from "@/library/CMSBannerCount";
import { VueEditor, Quill } from "vue2-editor";
import DateRangePicker from "@/library/DateTimeRangePicker.vue";
// import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';
// import 'vue2-daterange-picker/dist/lib/vue-daterange-picker2.min.css';
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const fileSizeValidation = (value, vm) =>  {
  if (!value) {
    return true;
  }
  let file = value;
  return (file.size < 1048576);
};
const base64Encode = data =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });


export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    CMSBannerCount,
    VueEditor,
    DateRangePicker
  },
  props: {
    // item: {
    //   type: Object
    // },
    viewType: {
      type: Number
    }
  },
  data() {
    return {
      target_window: "",
      item_order: 0,
      default_order: true,
      login_required: true,
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      en_alt: "",
      en_href: "",
      en_image_desktop: null,
      en_image_mobile: null,
      cn_alt: "",
      cn_href: "",
      cn_image_desktop: null,
      cn_image_mobile: null,
      local_alt: "",
      local_href: "",
      local_image_desktop: null,
      local_image_mobile: null,
      file: "",
      en_image_url_desktop: "",
      cn_image_url_desktop: "",
      local_image_url_desktop: "",
      en_image_url_mobile: "",
      cn_image_url_mobile: "",
      local_image_url_mobile: "",
      enDesktopImageName: "",
      cnDesktopImageName: "",
      localDesktopImageName: "",
      enMobileImageName: "",
      cnMobileImageName: "",
      localMobileImageName: "",
      enDesktopImageSrc: null,
      cnDesktopImageSrc: null,
      localDesktopImageSrc: null,
      enMobileImageSrc: null,
      cnMobileImageSrc: null,
      localMobileImageSrc: null,
      dateRange: {
        startDate: null,
        endDate: null,
      },
      activeTab: "en"
    };
  },
  computed: {
    imgSize() {
      return config.bannerDimension;
    },
    themeCode() {
      return this.$store.getters.selectedTheme;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    target_window: {
      required
    },
    login_required: {
      required
    },
    default_order: {
      required
    },
    item_order: {
      required : requiredIf(function () {
        return this.default_order == false;
      }),
      minValue(value) {
        if (this.default_order == true) {
          return minValue(0)(value)
        } else {
          return minValue(1)(value)
        }
      }
    },
    en_alt: {
      required
    },
    en_href: {
      required
    },
    cn_alt: {
      maxLength: maxLength(255)
    },
    cn_href: {
      maxLength: maxLength(500)
    },
    local_alt: {
      maxLength: maxLength(255)
    },
    local_href: {
      maxLength: maxLength(500)
    },
    en_image_desktop: {
      required : requiredIf(function () {
        return this.enDesktopImageSrc == null;
      }),
      fileSizeValidation
    },
    en_image_mobile: {
      fileSizeValidation
    },
    cn_image_desktop: {
      fileSizeValidation
    },
    cn_image_mobile: {
      fileSizeValidation
    },
    local_image_desktop: {
      fileSizeValidation
    },
    local_image_mobile: {
      fileSizeValidation
    },
  },
  watch: {
    en_image_desktop(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.enDesktopImageSrc = value;
            })
            .catch(() => {
              this.enDesktopImageSrc = null;
            });
        } else {
          this.enDesktopImageSrc = null;
        }
      }
    },
    cn_image_desktop(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.cnDesktopImageSrc = value;
            })
            .catch(() => {
              this.cnDesktopImageSrc = null;
            });
        } else {
          this.cnDesktopImageSrc = null;
        }
      }
    },
    local_image_desktop(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.localDesktopImageSrc = value;
            })
            .catch(() => {
              this.localDesktopImageSrc = null;
            });
        } else {
          this.localDesktopImageSrc = null;
        }
      }
    },
    en_image_mobile(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.enMobileImageSrc = value;
            })
            .catch(() => {
              this.enMobileImageSrc = null;
            });
        } else {
          this.enMobileImageSrc = null;
        }
      }
    },
    cn_image_mobile(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.cnMobileImageSrc = value;
            })
            .catch(() => {
              this.cnMobileImageSrc = null;
            });
        } else {
          this.cnMobileImageSrc = null;
        }
      }
    },
    local_image_mobile(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.localMobileImageSrc = value;
            })
            .catch(() => {
              this.localMobileImageSrc = null;
            });
        } else {
          this.localMobileImageSrc = null;
        }
      }
    }
  },
  methods: {
    setTab(tab) {
      this.activeTab = tab;
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD HH:mm:ss');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD HH:mm:ss');
    },
    removeEnDesktopImage() {
      this.en_image_desktop = null;
      this.en_image_url_desktop = "";
      this.enDesktopImageName = "";
      this.enDesktopImageSrc = null;
    },
    removeCnDesktopImage() {
      this.cn_image_desktop = null;
      this.cn_image_url_desktop = "";
      this.cnDesktopImageName = "";
      this.cnDesktopImageSrc = null;
    },
    removeLocalDesktopImage() {
      this.local_image_desktop = null;
      this.local_image_url_desktop = "";
      this.localDesktopImageName = "";
      this.localDesktopImageSrc = null;
    },
    removeEnMobileImage() {
      this.en_image_mobile = null;
      this.en_image_url_mobile = "";
      this.enMobileImageName = "";
      this.enMobileImageSrc = null;
    },
    removeCnMobileImage() {
      this.cn_image_mobile = null;
      this.cn_image_url_mobile = "";
      this.cnMobileImageName = "";
      this.cnMobileImageSrc = null;
    },
    removeLocalMobileImage() {
      this.local_image_mobile = null;
      this.local_image_url_mobile = "";
      this.localMobileImageName = "";
      this.localMobileImageSrc = null;
    },
    onSelectEnDesktop(evt) {
      if(evt.target.files.length > 0){
        this.enDesktopImageName = evt.target.files[0].name;
        // this.file = file;
      }else{
        return
      }
    },
    onSelectCnDesktop(evt) {
      if(evt.target.files.length > 0){
        this.cnDesktopImageName = evt.target.files[0].name;
      }else{
        return
      }
    },
    onSelectLocalDesktop(evt) {
      if(evt.target.files.length > 0){
        this.localDesktopImageName = evt.target.files[0].name;
      }else{
        return
      }
    },
    onSelectEnMobile(evt) {
      if(evt.target.files.length > 0){
        this.enMobileImageName = evt.target.files[0].name;
        // this.file = file;
      }else{
        return
      }
    },
    onSelectCnMobile(evt) {
      if(evt.target.files.length > 0){
        this.cnMobileImageName = evt.target.files[0].name;
      }else{
        return
      }
    },
    onSelectLocalMobile(evt) {
      if(evt.target.files.length > 0){
        this.localMobileImageName = evt.target.files[0].name;
      }else{
        return
      }
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.confirmSubmit();
      }
    },
    proceed() {
      let url = config.cmsSlideBannerAddUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        en_alt: this.en_alt,
        en_href: this.en_href,
        en_image_url_desktop: this.en_image_url_desktop,
        en_image_url_mobile: this.en_image_url_mobile,
        cn_alt: this.cn_alt,
        cn_href: this.cn_href,
        cn_image_url_desktop: this.cn_image_url_desktop,
        cn_image_url_mobile: this.cn_image_url_mobile,
        local_alt: this.local_alt,
        local_href: this.local_href,
        local_image_url_desktop: this.local_image_url_desktop,
        local_image_url_mobile: this.local_image_url_mobile,
        default_order: this.default_order,
        item_order: this.default_order == false ? this.item_order : null,
        target_window: this.target_window,
        login_required: this.login_required,
        active_from: this.dateRange.startDate,
        active_to: this.dateRange.endDate,
        view_type: this.viewType
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.addSlideBanner.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "add_slide_banner", this.feedback.status);
                this.$refs.addSlideBanner.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    async uploadEnDesktopImage() {
      if (this.enDesktopImageName == "")
        return;

      const formData = new FormData();
      formData.append("file", this.en_image_desktop);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.en_image_url_desktop = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async uploadCnDesktopImage() {
      if (this.cnDesktopImageName == "")
        return;

      const formData = new FormData();
      formData.append("file", this.cn_image_desktop);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.cn_image_url_desktop = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async uploadLocalDesktopImage() {
      if (this.localDesktopImageName == "")
        return;

      const formData = new FormData();
      formData.append("file", this.local_image_desktop);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.local_image_url_desktop = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async uploadEnMobileImage() {
      if (this.enMobileImageName == "")
        return;

      const formData = new FormData();
      formData.append("file", this.en_image_mobile);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.en_image_url_mobile = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async uploadCnMobileImage() {
      if (this.cnMobileImageName == "")
        return;

      const formData = new FormData();
      formData.append("file", this.cn_image_mobile);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.cn_image_url_mobile = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async uploadLocalMobileImage() {
      if (this.localMobileImageName == "")
        return;

      const formData = new FormData();
      formData.append("file", this.local_image_mobile);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.local_image_url_mobile = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async confirmSubmit() {
      const p1 = this.uploadEnDesktopImage();
      const p2 = this.uploadCnDesktopImage();
      const p3 = this.uploadLocalDesktopImage();
      const p4 = this.uploadEnMobileImage();
      const p5 = this.uploadCnMobileImage();
      const p6 = this.uploadLocalMobileImage();
      const someResult = await p1;
      const anotherResult = await p2;
      const someResult1 = await p3;
      const anotherResult1 = await p4;
      const someResult2 = await p5;
      const anotherResult2 = await p6;

      this.proceed();
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.activeTab = 'en';
    },
    shown: function() {
      this.target_window = "";
      this.default_order = true;
      this.login_required = true;
      this.item_order = 0;
      this.en_alt = "";
      this.en_href = "";
      this.en_image_desktop = null;
      this.en_image_mobile = null;
      this.cn_alt = "";
      this.cn_href = "";
      this.cn_image_desktop = null;
      this.cn_image_mobile = null;
      this.local_alt = "";
      this.local_href = "";
      this.local_image_desktop = null;
      this.local_image_mobile = null;
      this.en_image_url_desktop = ""
      this.cn_image_url_desktop = ""
      this.local_image_url_desktop = ""
      this.en_image_url_mobile = ""
      this.cn_image_url_mobile = ""
      this.local_image_url_mobile = ""
      this.enDesktopImageName = ""
      this.cnDesktopImageName = ""
      this.localDesktopImageName = ""
      this.enMobileImageName = ""
      this.cnMobileImageName = ""
      this.localMobileImageName = ""
      this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD 00:00:00');
      this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD 23:59:59');
      this.$v.$reset();
    }
  }
};
</script>
